export default __webpack_public_path__ + "static/media/6.f8c15958.svg";